import React from 'react'

const ModalVideo = ({ selected, setSelected }) => {
  const videoLoaded = (e) => {
    e.target.classList.remove('loading')
  }

  return (
    <div
      className={`modal modal--video  ${selected !== null ? 'is-active' : ''}`}
    >
      <div className='container pt-6 absolute top-0 right-0 left-0 z-20'>
        <div className='grid grid-cols-2 items-center'>
          <div>
            <p className='eyebrow color--white mb-0 flex items-end hidden md:block'>
              <svg
                version='1.1'
                id='Layer_1'
                xmlns='http://www.w3.org/2000/svg'
                viewBox='0 0 12 16'
                width='12px'
                height='16px'
                className='inline-block mr-3'
              >
                <rect
                  className='volume--bar-1'
                  x='10'
                  y='9'
                  fill='#fff'
                  width='2'
                  height='7'
                ></rect>
                <rect
                  className='volume--bar-2'
                  x='5'
                  fill='#fff'
                  width='2'
                  height='16'
                ></rect>
                <rect
                  className='volume--bar-3'
                  y='6'
                  fill='#fff'
                  width='2'
                  height='10'
                ></rect>
              </svg>{' '}
              <span>Best Served with Volume</span>
            </p>
          </div>
          <div className='col-start-2 text-right'>
            <a className='inline-block' onClick={() => setSelected(null)}>
              <svg
                width='12'
                height='12'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  fill='#fff'
                  d='M1.774 11.265L.612 10.102l9.499-9.5 1.162 1.163z'
                ></path>
                <path
                  fill='#fff'
                  d='M.61 1.765L1.771.603l9.5 9.499-1.163 1.162z'
                ></path>
              </svg>
            </a>
          </div>
        </div>
      </div>
      <div className='video--holder'>
        <video
          type='video/mp4'
          controls
          className='loading'
          onPlay={videoLoaded}
        ></video>
      </div>
    </div>
  )
}

export default ModalVideo
